import { render, staticRenderFns } from "./MovieItem.vue?vue&type=template&id=5b3572d0&scoped=true"
import script from "./MovieItem.vue?vue&type=script&lang=js"
export * from "./MovieItem.vue?vue&type=script&lang=js"
import style0 from "./MovieItem.vue?vue&type=style&index=0&id=5b3572d0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3572d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b3572d0')) {
      api.createRecord('5b3572d0', component.options)
    } else {
      api.reload('5b3572d0', component.options)
    }
    module.hot.accept("./MovieItem.vue?vue&type=template&id=5b3572d0&scoped=true", function () {
      api.rerender('5b3572d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/skinSetting/components/MovieItem.vue"
export default component.exports